import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useRole } from "../context/RoleContext";
import UnauthorizedPage from "../pages/errors/UnauthorizedPage";

export default function RoleGate({ views, roles }) {
  const { availableViews, activeView, setActiveView, roleKeys } = useRole();
  const roleAllowed = !roles || roles.some((role) => roleKeys.includes(role));
  const allowed = roleAllowed ? views.filter((v) => availableViews.includes(v)) : [];

  useEffect(() => {
    if (allowed.length && !allowed.includes(activeView)) setActiveView(allowed[0]);
  }, [allowed, activeView, setActiveView]);

  if (!allowed.length) return <UnauthorizedPage />;
  return <Outlet />;
}
